import { render, staticRenderFns } from "./ListGunsPage.vue?vue&type=template&id=de507680"
import script from "./ListGunsPage.vue?vue&type=script&lang=js"
export * from "./ListGunsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports